import axios, { AxiosResponse } from 'axios'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { Revision, RevisionStatus } from 'Definitions/Revision.type.ts'

import { ADMIN_API_ROOT, ADMIN_API_URL } from 'Constants/Global.admin.constants.ts'

import { getAxiosConfig } from 'Utils/auth.util.ts'
import { appendUrlSearchParams } from 'Utils/url.util.ts'
import { handleError } from 'Helpers/errors.helper.ts'

export interface RevisionProps {
  type?: 'EXAEUR1' | 'EXA'
  param: string
  minDate: string
  maxDate: string
  status: RevisionStatus
  pageIndex: number
  pageSize: number
  order: 'ASC' | 'DESC'
}

export const getOrdersRevision = async ({ type, param, status, minDate, maxDate, pageIndex, pageSize, order }: RevisionProps) => {
  const url = new URL(ADMIN_API_URL.INTERNAL_REVISION.ORDER)
  const params: Record<string, string | number | undefined> = {
    type,
    param,
    status,
    order,
    minDate: minDate,
    maxDate: maxDate,
    page: pageIndex,
    limit: pageSize,
  }

  appendUrlSearchParams(url, params)

  try {
    const { data }: AxiosResponse<{ data: Revision[]; total: number }> = await axios.get(url.toString(), getAxiosConfig())
    return {
      revisionList: data.data,
      total: data.total,
    }
  } catch (error) {
    handleError(error, true)
    throw error
  }
}

export const getPurchaseRevision = async ({ param, status, minDate, maxDate, pageIndex, pageSize, order }: RevisionProps) => {
  const url = new URL(ADMIN_API_URL.INTERNAL_REVISION.PURCHASE)
  const params: Record<string, string | number | undefined> = {
    param,
    status,
    order,
    minDate: minDate,
    maxDate: maxDate,
    page: pageIndex,
    limit: pageSize,
  }

  appendUrlSearchParams(url, params)

  try {
    const { data }: AxiosResponse<{ data: Revision[]; total: number }> = await axios.get(url.toString(), getAxiosConfig())
    return {
      revisionList: data.data,
      total: data.total,
    }
  } catch (error) {
    handleError(error, true)
    throw error
  }
}

export const exportPurchaseInternalRevision = async ({ minDate, maxDate }: { minDate: string, maxDate: string }) => {
  const url = `${ADMIN_API_ROOT}/export/internal-revision/purchase?minDate=${minDate}&maxDate=${maxDate}`

  try {
    const { data }: AxiosResponse<{ data: string }> = await axios.get(url, getAxiosConfig())
    return data
  } catch (error) {
    handleError(error, true)
    throw error
  }
}

export const exportOrderInternalRevision = async ({ minDate, maxDate }: { minDate: string, maxDate: string }) => {
  const url = `${ADMIN_API_ROOT}/export/internal-revision/certificate?minDate=${minDate}&maxDate=${maxDate}`

  try {
    const { data }: AxiosResponse<{ data: string }> = await axios.get(url, getAxiosConfig())
    return data
  } catch (error) {
    handleError(error, true)
    throw error
  }
}

export const dispatchGetOrdersRevision = createAsyncThunk('admin/dispatchGetOrdersRevision', getOrdersRevision)
export const dispatchGetPurchaseRevision = createAsyncThunk('admin/dispatchGetPurchaseRevision', getPurchaseRevision)
